import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>CCSU@90.8 FM Radio</h1>
                <p>Home &gt; CCSU@90.8 FM Radio</p>
            </div>
        </div>
    )
}

export default Hero;